import { createAction, createSlice } from '@reduxjs/toolkit';

const initialState = [];

const resetState = createAction('logoutSlice/logoutSuccess');

const getConfigValue = (detailId, detailValue) => {
  if (detailId === 'OTP_SEND_INTERVAL') return detailValue ?? '30';

  return detailValue;
};

export const dbConfigurationsSlice = createSlice({
  name: 'dbConfigurationsSlice',
  initialState,
  reducers: {
    dbConfigurationsRequest: (state) => state,
    dbConfigurationsSucess: (state, action) => {
      const updatedState = action.payload.reduce((acc, updatedConfig) => {
        const { detailId: updatedDetailId, value: updatedValue } =
          updatedConfig;

        const matchingConfigIndex = acc.findIndex(
          (config) => config.detailId === updatedDetailId,
        );

        if (matchingConfigIndex >= 0) {
          acc[matchingConfigIndex].value = getConfigValue(
            updatedDetailId,
            updatedValue,
          );

          return acc;
        }

        acc.push({
          detailId: updatedDetailId,
          value: getConfigValue(updatedDetailId, updatedValue),
        });

        return acc;
      }, state);

      return updatedState;
    },
    dbConfigurationsFailure: (state) => state,
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (state) => {
      const updatedState = state.filter(
        (item) =>
          item.detailId === 'ENFORCE_OTP_LOGIN' ||
          item.detailId === 'ENFORCE_OTP_CHANGE_PASSWORD' ||
          item.detailId === 'ENFORCE_OTP_RECOVER_PASSWORD' ||
          item.detailId === 'ENFORCE_OTP_STOCK_ORDER' ||
          item.detailId === 'ENFORCE_OTP_PRIMARY_ORDER' ||
          item.detailId === 'ENFORCE_OTP_FUNDS_PRIMARY' ||
          item.detailId === 'ENFORCE_OTP_FUNDS_MANAGER' ||
          item.detailId === 'OTP_SEND_INTERVAL' ||
          item.detailId === 'INACTIVITY_TIME' ||
          item.detailId === 'TIME_ZONE' ||
          item.detailId === 'ONBOARDING' ||
          item.detailId === 'ONBOARDING_OTP_START' ||
          item.detailId === 'ONBOARDING_OTP_END' ||
          item.detailId === 'ONBOARDING_OTP_DELIVERY_METHODS_END' ||
          item.detailId === 'ONBOARDING_CONTRACT_PREVIEW' ||
          item.detailId === 'ONBOARDING_DATA_ACCEPT' ||
          item.detailId === 'ONBOARDING_VIDEO_LINK' ||
          item.detailId === 'QUESTIONNAIRE',
      );

      return updatedState;
    });
  },
});
